var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    class: _vm.drawer
  }, [_c('b-navbar-brand', {
    staticClass: "mb-4",
    attrs: {
      "id": "hyperDrillMapsLogo",
      "to": "/dashboard"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "alt": "DrillMaps",
      "src": require("@/assets/logo.png"),
      "width": "140px"
    }
  })]), _c('div', {
    staticClass: "menu-area"
  }, [_c('div', {
    staticClass: "menus"
  }, [_c('List', {
    attrs: {
      "to": "/dashboard",
      "label": _vm.$t('adminNav.dashboard'),
      "icon": "dashboard"
    }
  })], 1), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "logout-button",
    on: {
      "click": function click($event) {
        return _vm.$root.logout();
      }
    }
  }, [_vm.getSideDrawer ? _c('span', [_vm._v(_vm._s(_vm.$t("adminNav.logout")))]) : _vm._e(), _vm._v("\n            "), _c('i', {
    staticClass: "fa fa-sign-out"
  })])])])], 1), _c('div', {
    class: _vm.backdrop,
    on: {
      "click": function click($event) {
        return _vm.$emit('click');
      }
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }